
const Menu = ()=>{

    return (
        <>
            <nav className="navbar">
                <p className="navbar-brand">@</p>
                <ul className="navbar-list">
                    <li className="nav-item" onClick={()=>{
                        let historias = document.getElementsByClassName('historias')[0];
                        historias.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>Historias</li>
                    <li className="nav-item" onClick={()=>{
                        let videojuegos = document.getElementsByClassName('videojuegos')[0];
                        videojuegos.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>Videojuegos</li>
                    <li className="nav-item"  onClick={()=>{
                        let personajes = document.getElementsByClassName('personajes')[0];
                        personajes.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>Personajes</li>

                </ul>

                <div className="burger-menu"
                     onClick={() => {
                    let barOne = document.getElementsByClassName("bar-1")[0];
                    let barTwo = document.getElementsByClassName("bar-2")[0];
                    let barThree = document.getElementsByClassName("bar-3")[0];
                    document.querySelector(".burger-menu").classList.toggle("active-menu");
                    barOne.classList.toggle("active1");
                    barTwo.classList.toggle("active2");
                    barThree.classList.toggle( "active3");
                    let burgerMenu = document.getElementsByClassName("burger-menu")[0];
                    burgerMenu.classList.toggle("burger-fixed");
                    let menu_mobile = document.getElementsByClassName("menu-mobile")[0];

                    menu_mobile.classList.toggle("active-menu-mobile");
                }} onMouseEnter={()=>{
                    let barOne = document.getElementsByClassName("bar-1")[0];
                    let barTwo = document.getElementsByClassName("bar-2")[0];
                    let barThree = document.getElementsByClassName("bar-3")[0];
                    barOne.style.backgroundColor="white";
                    barTwo.style.backgroundColor="white";
                    barThree.style.backgroundColor="white";
                }} onMouseLeave={()=>{
                    let barOne = document.getElementsByClassName("bar-1")[0];
                    let barTwo = document.getElementsByClassName("bar-2")[0];
                    let barThree = document.getElementsByClassName("bar-3")[0];
                    barOne.style.backgroundColor="#FFB008";
                    barTwo.style.backgroundColor="#FFB008";
                    barThree.style.backgroundColor="#FFB008";
                }}>
                    <div className="bar bar-1"></div>
                    <div className="bar bar-2"></div>
                    <div className="bar bar-3"></div>
                </div>

                <ul className="menu-mobile  ">
                    <li className="item-mobile" onClick={()=>{
                        let historias = document.getElementsByClassName('historias')[0];
                        historias.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>historias</li>
                    <li className="item-mobile" onClick={()=>{
                        let videojuegos = document.getElementsByClassName('videojuegos')[0];
                        videojuegos.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>videojuegos</li>
                    <li className="item-mobile"onClick={()=>{
                        let personajes = document.getElementsByClassName('personajes')[0];
                        personajes.scrollIntoView( {behavior: "smooth", block: "start" });
                    }}>personajes</li>

                </ul>
            </nav>
        </>
    )
}

export default Menu;